import { ContactEmail } from '@base/common/Contact';
import Iconfont from '@base/lib/Iconfont';
import site from 'pro/config/site';
import styles from '@pro/help/default.module.less';
import { LoopRender } from '@base/snippets/LoopRender';
import { domains } from './config';

export default function FraudAwareness() {
    return (
        <div className={styles.help}>
            <h1>Official Statement on Fraud Websites</h1>
            <p>In recent times, a disturbing development has come to our attention. Fake websites pretending to be {site.brand} have appeared on platforms such as Facebook, engaging in misleading clearance sales that have resulted in confusion and inconvenience for our valued customers. The list of identified websites in question include:</p>
            <LoopRender
                className="text-danger g-no-bullet"
                tag={'ul'}
                list={domains}
                render={item => (
                    <li>
                        <Iconfont className="icon-close-translucent"/> <strong>{item}</strong>
                    </li>
                )}
            />
            <p>We urge all of our customers to exercise caution and diligently verify the authenticity of the websites and retailers with whom they engage. It is imperative that you exclusively transact with our official website, authorized platform stores, and licensed sales channels for all your {site.brand} product requirements.</p>
            <p>If you should have any concerns or inquiries, please do not hesitate to reach out to our official customer service team at <ContactEmail/></p>
        </div>
    )
};